'use client';

import { c as _c } from "react/compiler-runtime";
import { ReactionBar } from './ReactionBar';
import { VoteButtons } from './VoteButtons';
interface ActivityOperationsProps {
  objectId: string;
  objectType: 'item' | 'collection' | 'entity' | 'collection_item' | 'initiative' | 'content';
  showVotes?: boolean;
  showReactions?: boolean;
  dialogEnabled?: boolean;
  title?: string;
  details?: React.ReactNode;
}
export function ActivityOperations(t0) {
  const $ = _c(14);
  const {
    objectId,
    objectType,
    showVotes: t1,
    showReactions: t2,
    dialogEnabled: t3,
    title,
    details
  } = t0;
  const showVotes = t1 === undefined ? true : t1;
  const showReactions = t2 === undefined ? true : t2;
  const dialogEnabled = t3 === undefined ? false : t3;
  if (!showVotes && !showReactions) {
    return null;
  }
  let t4;
  if ($[0] !== objectId || $[1] !== objectType || $[2] !== showVotes) {
    t4 = showVotes && <VoteButtons objectId={objectId} objectType={objectType} />;
    $[0] = objectId;
    $[1] = objectType;
    $[2] = showVotes;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== details || $[5] !== dialogEnabled || $[6] !== objectId || $[7] !== objectType || $[8] !== showReactions || $[9] !== title) {
    t5 = showReactions && <div className="flex-1 self-center"><ReactionBar objectId={objectId} objectType={objectType} dialogEnabled={dialogEnabled} title={title} details={details} /></div>;
    $[4] = details;
    $[5] = dialogEnabled;
    $[6] = objectId;
    $[7] = objectType;
    $[8] = showReactions;
    $[9] = title;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <div className="flex items-center gap-6">{t4}{t5}</div>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}